module.exports = require('./lib/eql');



//////////////////
// WEBPACK FOOTER
// ./~/deep-eql/index.js
// module id = 44
// module chunks = 1 3